import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import * as actions from '../actions'
import scrollIntoView from 'scroll-into-view-if-needed'
import { AppState } from '../reducers'
import { AppMode } from '../constants'
import { Product, Unit, buildProductImagesLinks } from '../services/assortment.service'
import NumberInput from '../components/NumberInput'

type PartProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>
    & { article: Product, selected: boolean, expanded: boolean }

class Part extends React.Component<PartProps> {
    countInput: HTMLInputElement
    partRef: HTMLDivElement

    render() {
        const { article, expanded, appMode, onImageClick, onChange, onClick, unClick, order } = this.props

        const name = article.namePL;

        const clickFn = () => {
            if (this.props.selected) {
                unClick();
            } else {
                onClick(article);
            }
        }

        const { listPath } = buildProductImagesLinks(article);

        const getUnitShort = (unit: Unit): string => {
            switch (unit.description) {
                case 'Sztuki':
                    return 'Szt.';
                case 'Opakowanie':
                    return 'Opk.';
                default:
                    return unit.unit;
            }
        }

        const getUnitString = (unit: Unit, showCount: boolean = true): string => {
            if (unit.converter !== 1.0) {
                return `${unit.description}${showCount ? ` (${unit.converter} Szt.)` : ''}`;
            }

            return unit.description
        }

        return (
            <div className="kr-part">
                <div className={`kr-part-header ${expanded ? 'kr-part-header-selected' : ''}`} onClick={clickFn}>
                    <div>{article.nr}</div>
                    <div>{name}</div>
                    {appMode === AppMode.Order && !expanded &&
                        <div className='order-amount-display'>
                            {article.id in order &&
                                <>
                                    {order[article.id].map(o =>  {
                                        return o.count !== 0 && <div className='order-amount'>
                                                {o.unit.converter !== 1 ? (
                                                    <div className="popup-container">
                                                        <div>{getUnitShort(o.unit)}</div>
                                                        <div className="popup-box">{o.unit.converter} Szt.</div>
                                                    </div>
                                                ) : (
                                                    <div>{getUnitShort(o.unit)}</div>
                                                )}
                                                <div>{o.count}</div>
                                            </div>
                                    })}
                                </>
                            }
                        </div>
                    }
                </div>
                <div ref={node => { this.partRef = node }} className={`kr-part-body`} style={{ height: '0px' }}>
                    {appMode === AppMode.Order &&
                        <div id="kr-part-amount-adjust">
                            {article.units.map(u => {
                                return (<div className="qunatity-input">
                                        <p>{getUnitString(u)}</p>
                                        <NumberInput
                                            value={article.id in order ? order[article.id].find(o => o.unit.converter === u.converter)?.count ?? 0 : 0}
                                            setValue={(value) => onChange(article.id, value, u)}
                                            defaultValue={0}
                                            maxValue={10000}
                                        />
                                    </div>
                                )})
                            }
                        </div>
                    }
                    <img className={`kr-part-image ${appMode === AppMode.Order ? 'kr-part-image-border' : ''}`} onClick={() => onImageClick(this.props.listImages.get(listPath))} src={this.props.listImages.get(listPath)?.toString() ?? ''} alt="" />
                </div>
            </div>
        )
    }

    componentDidUpdate() {
        if (this.props.selected) {
            let adjusterHeight = 0;
            if (this.props.appMode === AppMode.Order) adjusterHeight = this.partRef.querySelector<HTMLDivElement>('#kr-part-amount-adjust')!.getBoundingClientRect().height;
            const imageHeight = this.partRef.querySelector('img')!.getBoundingClientRect().height;
            const height = (adjusterHeight + imageHeight).toString() + 'px';
            scrollIntoView(ReactDOM.findDOMNode(this.partRef), {
                scrollMode: 'if-needed',
                block: 'end',
                inline: 'nearest'
            });
            this.partRef.animate([
                { height: height }
            ], {
                duration: 150,
                fill: 'forwards'
            }).addEventListener('finish', () => {
                scrollIntoView(ReactDOM.findDOMNode(this.partRef), {
                    scrollMode: 'if-needed',
                    block: 'end',
                    inline: 'nearest'
                });
            });
        } else {
            this.partRef.animate([
                { height: '0px' }
            ], {
                duration: 150,
                fill: 'forwards'
            });
        }
    }
}

const mapStateToProps = (state: AppState) => ({
    appMode: state.config.appMode,
    lang: state.lang,
    listImages: state.listImages,
    order: state.order,
    filters: state.filters
})

const mapDispatchToProps = dispatch => ({
    onImageClick: (src) => {
        dispatch(actions.modal(src))
    },
    onChange: (id: number, value: string, unit: Unit) => {
        const count = Number(value);
        if (isNaN(count)) {
            alert('Nieprawidłowa wartość.');
        } else {
            dispatch(actions.editOrder(id, count, unit));
        }
    },
    onClick: (product: Product) => {
        dispatch(actions.selectArticleAction(product.id))
        dispatch(actions.togglePartImage())
    },
    unClick: () => {
        dispatch(actions.selectArticleAction(-1))
        dispatch(actions.togglePartImage())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Part)